import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-coupon-already-exists',
  templateUrl: './coupon-already-exists.component.html',
  styleUrl: './coupon-already-exists.component.scss',
  standalone: false,
})
export class CouponAlreadyExistsComponent {
  public couponCode: string;
  constructor(
    private dialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {
    this.couponCode = this.config.data.couponCode;
  }
  public closeDialog(): void {
    this.dialogRef.close();
  }

  public copyToClipboard(text: string): void {
    navigator.clipboard
      .writeText(text)
      .then(() => {})
      .catch(err => {
        console.error('Failed to copy text to clipboard', err);
      });
  }
}
